import { SEARCH_ARTICLES } from "../../../constants/actionTypes";
import store from "../../../store/index";
import { intentDataService, getSearchArticlesService, updateKeywordsService } from "../../Services/SearchService";
import { serializeArticles } from "../WhatsHappeningNow/utils";
import { IArticlesItem } from "./../interfaces";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import {
  ASSET_DETAILS_UPDATE_KEYWORDS,
  ASSET_LIST,
  CAMPAIGN_SENT_EDITIONS,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS,
  EMAIL_LIST,
} from "../../../constants/types";
import { GLOBAL_ACTION } from "modules/GlobalActions";
import axios from "axios";

// get search articles from api based on keywowrds
export const getSearchArticles = (
  searchParams: string[],
  offset: number,
  limit: number,
  sortBy?: number,
  dates?: { start_date: string; end_date: string },
  favourites?: boolean,
  advancedFilter?: boolean,
  sourcedContent?: any[],
  excludedContent?: any[],
  excludedKeywords?: string[],
  includedKeywords?: string[],
  save?: boolean
) => {
  // add search terms in query param
  // let querySearchParams: string = searchParams.map((param) => "search=" + param).join("&");

  let versionId = getQueryEmailId();
  let campaignId = getQueryCampaignId();

  // for post request
  let searchObject: any = {};
  searchObject.searchTerms = searchParams.map((word: string) => word.replaceAll("#", ""));
  searchObject.limit = limit;
  searchObject.offset = offset;
  searchObject.version_id = versionId;
  if (sortBy) searchObject.sort_by = sortBy;
  if (dates) {
    searchObject.start_date = dates.start_date;
    searchObject.end_date = dates.end_date;
  }
  if (favourites == true) {
    searchObject.favourites = 1;
  }
  if (advancedFilter) {
    searchObject.advanced_search = advancedFilter;
    store.dispatch({
      type: GLOBAL_ACTION.ADVANCED_SEARCH_CHECK,
      payload: true,
    });
    if (campaignId !== undefined || campaignId !== null) {
      searchObject.campaignId = campaignId;
    }
  }
  if (sourcedContent) {
    searchObject.include_sources = sourcedContent;
  }
  if (excludedContent) {
    searchObject.exclude_sources = excludedContent;
  }
  if (excludedKeywords) {
    searchObject.exclude_keywords = excludedKeywords;
  }
  if (includedKeywords) {
    searchObject.include_keywords = includedKeywords;
  }
  if (save) {
    searchObject.save = save;
  }
  // querySearchParams += `&limit=${limit}&offset=${offset}&version_id=${versionId}`; //adding limit,offset, version id
  // if (sortBy !== undefined && dates !== undefined) {
  //   querySearchParams += `&sort_by=${sortBy}&start_date=${dates.start_date}&end_date=${dates.end_date}`;
  // }
  // let contentExplorer = store.getState().user.contentExplorer;
  // let contentExplorerStep = store.getState().user.contentExplorerStep;

  if (offset === 0)
    store.dispatch({
      type: SEARCH_ARTICLES.FIRST_LOAD,
      payload: [],
      article_count: 0,
    });
  else
    store.dispatch({
      type: SEARCH_ARTICLES.LOAD,
    });

  getSearchArticlesService(searchObject)
    .then((res) => {
      const serializedData: IArticlesItem[] = serializeArticles(res.data["articles"]);
      const articlesCount = res.data["articles_count"];
      store.dispatch({
        type: SEARCH_ARTICLES.LOAD_SUCCESS,
        payload: serializedData,
        offset: offset,
        article_count: articlesCount,
      });
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        if (err.message === "Operation canceled due to new request.") {
          store.dispatch({
            type: SEARCH_ARTICLES.LOAD,
          });
        } else {
          store.dispatch({
            type: SEARCH_ARTICLES.LOAD_FAIL,
            payload: [],
          });
        }
      } else {
        store.dispatch({
          type: SEARCH_ARTICLES.LOAD_FAIL,
          payload: [],
        });
      }
    });
};

// get search articles from api based on keywowrds
export const updateKeywordsAPI = (
  keywords: String[],
  entityId: Number,
  isCampaign: Number,
  assetWithoutCampaign?: boolean
) => {
  // add search terms in query param
  updateKeywordsService(keywords, entityId, isCampaign)
    .then((res) => {
      if (isCampaign === 1) {
        // store.dispatch({
        //   // This action will update the searched terms in the store that are to be highlighted in the article preview sidebar
        //   type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
        //   payload: keywords,
        // });
        store.dispatch({
          type: ASSET_LIST.UPDATE_KEYWORDS,
          payload: { campaign_keywords: keywords },
        });
        store.dispatch({
          type: EMAIL_LIST.UPDATE_CAMPAIGN_KEYWORDS,
          payload: keywords,
        });
      } else if (assetWithoutCampaign) {
        store.dispatch({
          type: ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.SUCCESS,
          keywords: keywords,
        });
      } else {
        // store.dispatch({
        //   // This action will update the searched terms in the store that are to be highlighted in the article preview sidebar
        //   type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
        //   payload: keywords,
        // });
        store.dispatch({
          type: EMAIL_LIST.UPDATE_CAMPAIGN_KEYWORDS,
          payload: keywords,
        });
        store.dispatch({
          type: ASSET_DETAILS_UPDATE_KEYWORDS.SUCCESS,
          payload: keywords,
        });
        store.dispatch({
          type: CAMPAIGN_SENT_EDITIONS.KEYWORDS_UPDATE,
          payload: keywords,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateKeywordsForUI = (keywords: any) => {
  store.dispatch({
    type: ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.SUCCESS,
    keywords: keywords,
  });
};

export const resetSearchedArticles = () => {
  store.dispatch({
    type: SEARCH_ARTICLES.RESET_TOTAL_COUNT,
  });
};

export const getIntentData = (id: number, type: string) => {
  store.dispatch({
    type: SEARCH_ARTICLES.FIRST_LOAD,
    payload: [],
    article_count: 0,
  });
  return intentDataService(id, type);
};
